module.exports = __webpack_public_path__ + "img/dialog_bg4.e43fb71d.jpg";